import * as React from "react"
import PropTypes from "prop-types"
import Button from "../components/button"
import { Link } from "gatsby"

const Header = ({ siteTitle }) => (
  <header className='masthead'>
    <div className="flex p20 align-center"> 
      <Link to="/" className=''>
        <div className='main--logo'></div>
      </Link>
      <div className="mla flex align-center">
        <Button />
      </div>
    </div>
       
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
